import { useHasActiveAccountingIntegration } from 'shared/components/Integrations/Integrations.utils';
import type { StepType } from './api';
import { usePrefetchTemplates } from './api';
import { TemplateGroupList } from './TemplateGroupList';

type RecoveryTemplatesProps = {
  searchQuery: string;
};

export const RecoveryTemplates = ({ searchQuery }: RecoveryTemplatesProps) => {
  usePrefetchTemplates({ templateType: 'payment_plan' });
  const hasActiveAccountingIntegration = useHasActiveAccountingIntegration();

  const stepTypes = hasActiveAccountingIntegration
    ? RECOVERY_GROUP_STEP_TYPES.filter(stepType => !INVOICING_STEP_TYPES.includes(stepType))
    : RECOVERY_GROUP_STEP_TYPES;

  return (
    <TemplateGroupList templateType="recovery" stepTypes={stepTypes} searchQuery={searchQuery} />
  );
};

const INVOICING_STEP_TYPES: readonly StepType[] = ['invoice', 'credit_note'];

const RECOVERY_GROUP_STEP_TYPES = [
  'invoice',
  'credit_note',
  'preventive_reminder',
  'first_reminder',
  'intermediate_reminder',
  'last_reminder',
  'additional_reminder',
  'formal_notice',
] as const;
